import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { api } from "@/lib/api";
import { startGoogleLogin, useCustomer } from "@/context/CustomerContext";

const Shell = ({ children, testid }) => (
  <main data-testid={testid} className="grid min-h-screen place-items-center px-5 py-16">
    <div className="w-full max-w-md border border-[rgba(152,191,162,0.25)] bg-[#0b120e] p-8 md:p-10">
      <Link to="/" data-testid="nutri-gate-home-link"><LogoMark size={48} /></Link>
      {children}
    </div>
  </main>
);

export const NutriLogin = () => (
  <Shell testid="nutri-login-screen">
    <p className="eyebrow mt-8">App NUTRI</p>
    <h1 className="mt-2 font-display text-5xl font-900 uppercase leading-[0.9]">Traccia la tua<br />alimentazione.</h1>
    <p className="mt-4 text-[#a3b1aa]">Accedi con l'account Google che corrisponde all'email usata per l'acquisto di NUTRI.</p>
    <button data-testid="google-login-btn" onClick={startGoogleLogin}
      className="mt-8 flex w-full items-center justify-center gap-3 bg-[#98bfa2] py-4 font-display text-lg font-800 uppercase text-[#050807] transition-colors hover:bg-[#c4dcca]">
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true"><path fill="#050807" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" /></svg>
      Accedi con Google
    </button>
  </Shell>
);

export const NutriNoAccess = () => {
  const { customer, logout } = useCustomer();
  const [nutriId, setNutriId] = useState(null);
  useEffect(() => {
    api.get("/products")
      .then((r) => setNutriId((Array.isArray(r.data) ? r.data : []).find((p) => p.name?.includes("NUTRI"))?.id ?? null))
      .catch(() => setNutriId(null));
  }, []);
  return (
    <Shell testid="nutri-no-access-screen">
      <p className="eyebrow mt-8">Accesso non attivo</p>
      <h1 className="mt-2 font-display text-4xl font-900 uppercase leading-[0.9]">NUTRI non è ancora sbloccata</h1>
      <p className="mt-4 text-[#a3b1aa]">
        Non troviamo un acquisto di NUTRI per <span className="text-[#c4dcca]" data-testid="nutri-user-email">{customer?.email}</span>. Acquistala usando questa email, poi torna qui.
      </p>
      <Link to={nutriId ? `/prodotto/${nutriId}` : "/"} data-testid="nutri-buy-link"
        className="mt-8 block bg-[#98bfa2] py-4 text-center font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca]">
        Vai a NUTRI
      </Link>
      <button data-testid="nutri-logout-btn" onClick={logout} className="mt-4 flex w-full items-center justify-center gap-2 font-mono text-xs uppercase tracking-widest text-[#a3b1aa] hover:text-[#c4dcca]">
        <LogOut size={14} /> Esci
      </button>
    </Shell>
  );
};
